import cx from "classnames";
import { type TestStatus, TestsStatusIcon } from "@ui-icons";
import AiAssistantExpandableTree from "../../../../../AiAssistantExpandableTree/AiAssistantExpandableTree";
import type { ToolCallNodeCompletedProps } from "../../../../ToolCallIndicator.types";
import { getToolCallCompletedPresentation } from "../../../../ToolCallIndicator.utils";
import ToolCallIndicatorCompletedOutput from "../../../ToolCallIndicatorCompletedOutput/ToolCallIndicatorCompletedOutput";
import ToolCallIndicatorNodeLabel from "../ToolCallIndicatorNodeLabel/ToolCallIndicatorNodeLabel";
import ToolCallIndicatorNodeNameLabel from "../ToolCallIndicatorNodeNameLabel/ToolCallIndicatorNodeNameLabel";
import ToolCallIndicatorNodeOptionalInputBlock from "../ToolCallIndicatorNodeOptionalInputBlock/ToolCallIndicatorNodeOptionalInputBlock";

export default function ToolCallIndicatorNodeCompleted({
  toolCallId,
  name,
  input,
  hasInputParseError,
  body,
  isError,
}: ToolCallNodeCompletedProps) {
  const { effectiveError, isEmpty, formattedBody, statusText, styles } =
    getToolCallCompletedPresentation(name, body, isError);

  let status: TestStatus = "success";
  if (effectiveError) {
    status = "error";
  } else if (isEmpty) {
    status = "warning";
  }
  return (
    <div data-tool-call-id={toolCallId} className="w-full">
      <AiAssistantExpandableTree
        framed
        title={
          <>
            <TestsStatusIcon status={status} />
            <ToolCallIndicatorNodeNameLabel name={name} />
            <span
              className={cx("ml-auto text-[11px] font-medium", styles.statusText)}
            >
              {statusText}
            </span>
          </>
        }
      >
        <ToolCallIndicatorNodeOptionalInputBlock
          input={input}
          hasInputParseError={hasInputParseError}
          layout="completed"
          wrapInTreeItem
        />
        <AiAssistantExpandableTree.Item branchYOffset="0.9em">
          <ToolCallIndicatorNodeLabel>Output</ToolCallIndicatorNodeLabel>
          <ToolCallIndicatorCompletedOutput
            isError={effectiveError}
            isEmpty={isEmpty}
            formattedBody={formattedBody}
          />
        </AiAssistantExpandableTree.Item>
      </AiAssistantExpandableTree>
    </div>
  );
}
